export function mustGetElementById<T extends HTMLElement>(id: string): T {
  const elementOrNull = document.getElementById(id) as T | null;
  if (elementOrNull === null) throw new Error(id + ' is missing in the document');
  return elementOrNull;
}

export function mustQuerySelectorAtIndex<T extends HTMLElement>(
  selector: string,
  index: number,
  nameForError: string
): T {
  const elements = document.querySelectorAll(selector);
  const elementOrNull = elements.item(index) as T | null;
  if (elementOrNull === null) throw new Error(nameForError + ' is missing in the document');
  return elementOrNull;
}

export const isVisible = (el: HTMLElement) => {
  do {
    if (el.getAttribute('aria-hidden') === 'true') return false;
    el = el.parentElement!;
  } while (el.id !== 'api');
  return true;
}

export const getVisibleTextContent = (el: HTMLElement) => ((isVisible(el) && el.textContent) || '').trim();

export function mustGetElementByName<T extends HTMLElement>(name: string): T {
  const elementOrNull = document.getElementsByName(name)[0] as T | null; // assume there is only one item with this name
  if (elementOrNull === null) throw new Error(name + ' is missing in the document');
  return elementOrNull;
}
